import axios from "axios";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { protectedResources } from "../authConfig";

// Generic function that will post data to the api. Uses axios.
// it is preceeded with a request for a new access token from the ADB2C client for every call. 
const postApiWithToken = async (account, instance, inProgress, url, body) => {
    const tokenResponse = await instance.acquireTokenSilent({
      scopes: protectedResources.api.scopes,
      account: account
    }).catch(async (error) => {
        // in case if silent token acquisition fails, fallback to an interactive method
        if (error instanceof InteractionRequiredAuthError) {
            if (account && inProgress === "none") {
                const popupResponse = await instance.acquireTokenPopup({
                    scopes: protectedResources.api.scopes,
                });
                return submit(popupResponse.accessToken, url, body);
            }
        }
    });
    return submit(tokenResponse.accessToken, url, body);
};

const submit = (token, url, body) => (
    axios
    .post(url, body, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
        })
    .then(response => {
        return response
    })
    .catch(error => {
        return error
    })
);
  
export default postApiWithToken;